module.exports = __webpack_public_path__ + "img/menu-my-transaction.f18022dd.svg";